const Marionette = require('backbone.marionette');

// Routers used by the login application don't use the baseRouter because that router is set up to check auth. 
module.exports = function (appRoutes, api) {
  let Router = Marionette.AppRouter.extend({
    appRoutes: appRoutes,
    controller: api
  });
  new Router();
};